import stateFilterStore from '@/stores/stateFilterStore';
import { SlidersHorizontal } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import { useParams, usePathname } from 'next/navigation';

const FilterButton = observer(() => {
  const { section } = useParams();
  const pathname = usePathname();
  let sectionValue = section;
  if (section === undefined) sectionValue = 'woman';
  return (
    <>
      <Link
        href={`/catalog/${sectionValue}/filter`}
        onClick={() =>
          pathname === `/catalog/${sectionValue}/filter`
            ? stateFilterStore.setHideFilter(!stateFilterStore.hideFilter)
            : ''
        }
      >
        <div className="flex items-center gap-2 pb-2">
          <SlidersHorizontal width={24} height={24} strokeWidth="2" />
          <p>Фильтры</p>
        </div>
      </Link>
    </>
  );
});
export default FilterButton;
